export const nameCombiner = (
    firstName: string | undefined,
    middleName: string | undefined,
    lastName: string | undefined
) => {
    return `${firstName || ''}${middleName ? ` ${middleName}` : ''}${
        lastName ? ` ${lastName}` : ''
    }`;
};
